import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import { selectScheduledTasksQueryItems } from '../../../../../redux/scheduled-tasks/selector';
import { scheduledTasks } from '../../../../../redux/scheduled-tasks/action';
import { toast } from 'react-toastify';
import ScheduleTaskComponent from '../components/scheduled-tasks.component';
import * as R from 'ramda';
import { deepCopy } from '../../../../../common/services/common.service';
import PageLoader from '../../../../../components/PageLoader';
import { getDHMS, getSeconds } from '../../../../../common/services/time.service';

let currentChange: any = {}
const ManagementScheduledTask= () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const queryItems = useSelector(selectScheduledTasksQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)

const [
  scheduledTask,
  setScheduledTasks
] = useState<any>([])

const [
  scheduleCommands,
  setScheduleCommands
] = useState<any>([])

const fetchRecordById= ()=>{
  dispatch(scheduledTasks.query({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/system/scheduled-tasks/query`,entity:'scheduledTasks',jsonData:{
        
  Records: [
    {
      
        
            "Id": parmas?.id
        
    
     
    }
  ]

}})).then(()=>{
setIsQuery(true)
})

}

useEffect(
  () => {
    if (parmas?.id > 0) {
      fetchRecordById()
      setIsLoading(false)
    }
    else{
      const localSelectedService = addNewRow({ selectedServiceArg: scheduleCommands });
      setScheduleCommands(localSelectedService)

      setIsLoading(false)
    }
  }
  ,
  []
)

useEffect(
  () => {
      
    if (isQuery) {
      const tasksWithDHMS = queryItems?.result?.items.map((task: any) => ({
        ...task,
        DHMS: getDHMS(task.Seconds),
      }));
      setScheduledTasks(tasksWithDHMS[0]);
      const localSelectedService = addNewRow({ selectedServiceArg: queryItems?.result?.items[0]?.ScheduleCommands });
      setScheduleCommands(localSelectedService)
    }
  },
  [isQuery]
)

const handleFormItemChange: any = ({ value, field, idx }: any) => {
  const items = deepCopy(scheduleCommands);// deep copy of grn items
  let item = items[idx];// deep copy of item to be edited
  item = { ...item, [field]: value }// updated the particular item
  items[idx] = item;
  currentChange = { value, field, idx }
  setScheduleCommands(items);
}
const deleteSelectedService = async (Item: any, index: any) => {
  if (Item.Id === 0) {
    scheduleCommands?.splice(
      index,
      1
    )
  }
}
const addNewRow = ({ selectedServiceArg }: any) => {
  const localSelectedservice = deepCopy(selectedServiceArg)
  const newRowFieldConversion = {
    Command: '',
    ScheduleCommandTypeId: '',
    Instruction: '',
    DisplayOrder: '',
  }
  if (localSelectedservice?.length === 0 ||
      localSelectedservice[localSelectedservice?.length - 1]?.Command !== '' 
  ) {
    localSelectedservice?.push(newRowFieldConversion)
  }

  return localSelectedservice
}

const setCombinationInfo = async () => {
  let localSelectedService = deepCopy(scheduleCommands)
  localSelectedService.splice(
    currentChange.idx,
    1,
    { ...localSelectedService[currentChange.idx] }
  );
  localSelectedService = addNewRow({ selectedServiceArg: localSelectedService });
  currentChange.field = 'CommandDONE'
  setScheduleCommands(localSelectedService)
}
useEffect(
  () => {
    if (currentChange.field === 'Command' && currentChange.field !== null) {
      setCombinationInfo();
  }
  },
  [scheduleCommands]
)

const handleInnerBasicFormChange: any = (event: any, field: string) => {
  setScheduledTasks({ ...scheduledTask, [field]: event });
}
const handleInnerFormChange: any = (event: any, field: string, data: any) => {
  const fields = R.split(
    '.',
    field
  );
  const value = { ...data, [fields[1]]: event }// inner data update
  setScheduledTasks({ ...scheduledTask, [fields[0]]: value });
}

const handleFormSubmit = async (event: any) => {
  event.preventDefault();
  scheduleCommands.splice(
    scheduleCommands.length - 1,
    1
  )
  scheduledTask.ScheduleCommands = scheduleCommands
  const updatedTask = { ...scheduledTask, ScheduleCommands: scheduleCommands };
  updatedTask.Seconds = getSeconds(updatedTask.DHMS);

  if (parmas?.id > 0) {
     
        
    dispatch(scheduledTasks.update({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/system/scheduled-tasks`,entity:'scheduledTasks',jsonData:{
         
   Records: [
    updatedTask
     
   ]

}})).then(()=>{
 back()
})

   }else{
     dispatch(scheduledTasks.create({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/system/scheduled-tasks`,entity:'scheduledTasks',jsonData:{
         
     Records: [
      updatedTask
     ]
   
 }})).then(()=>{
  back()
})
}
}
const back=()=>{
  navigate('/management/system/scheduled-tasks')
}

 
    return (
    <>
     {isLoading ? <PageLoader /> : 
        <ScheduleTaskComponent
  handleInnerFormChange={handleInnerFormChange}
  handleInnerBasicFormChange={handleInnerBasicFormChange}
  handleFormSubmit={handleFormSubmit}
  back={back}
  handleFormItemChange = {handleFormItemChange}
  deleteSelectedService = {deleteSelectedService}
  scheduleCommands={scheduleCommands}
  id={parmas?.id}
  scheduledTask={scheduledTask}
  /> 
     }
          </>
    )
    
    }
   
    export default ManagementScheduledTask;